import { twMerge } from "tailwind-merge";

/** Shared LGV input chrome (text, textarea, number). */
export function lgvInputClassName(
  disabled = false,
  className?: string,
): string {
  return twMerge(
    "w-full rounded-md border bg-white p-2 text-[#1B365D] transition-colors placeholder:text-gray-400",
    disabled
      ? "cursor-not-allowed border-gray-200 bg-gray-100 opacity-50"
      : "border-gray-300 hover:border-[#1B365D]/40 focus:outline-none focus:ring-2 focus:ring-blue-500",
    className,
  );
}
